export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const RESET_STORE = 'RESET_STORE';
